const BASE_URL = process.env.PURCHASE_FUNDING_API_URL;

export const PURCHASE_FUNDING_ENDPOINTS = {
  COAPPLICANT_ELIGIBILITY: `${BASE_URL}/api/v1/coapplicant/eligibility`,
  GET_APPROVED_LENDER_OPTIONS: `${BASE_URL}/api/v1/paymentoptions/self-arranged-financing/lien-holders`,
  GET_DOWN_RECIRCULATION: `${BASE_URL}/api/v1/recirculation/down-recirculation`,
  GET_SAF_INSTITUTIONS: `${BASE_URL}/api/v2/thirdpartyloan/institutions`,
  SAVE_SAF_LOAN_INFORMATION: `${BASE_URL}/api/v2/thirdpartyloan/information`,
  IDENTITY: `${BASE_URL}/api/v1/identity`,
  PAYMENT_OPTIONS: `${BASE_URL}/api/v1/paymentoptions`,
  PAYMENT_TERMS: `${BASE_URL}/api/v1/terms`,
  THIRD_PARTY_LOAN_DETAILS: `${BASE_URL}/api/v1/thirdpartyloan/information`,
  TOGGLE_COAPPLICANT: `${BASE_URL}/api/v1/coapplicant/toggle`
};
